import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import privateView from '../../components/hocs/privateView';
import MenuForm from './MenuForm';
import Analytics from "../../services/Analytics";

class MenuDetail extends Component{
	componentDidMount(){
    const { email } = this.props.injectedProps;
    Analytics.recordPageView('menu_detail', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }
  render(){
    return(
      <Container>
        <MenuForm 
          edit
          title="Menu Detail" 
          {...this.props}
        />
      </Container>
    )
  }
}

const mapStateToProps = ({auth: { isFetch, roles, isLogged, id, email } })=>({
    guardData: { isFetch, roles, isLogged, id, email }
  })
  
const enhance = connect(mapStateToProps);
export default enhance(privateView(MenuDetail))